import React, { useContext, useEffect, useState } from 'react';
import { IntegrationMetadata, IntegrationSettings, MerchantIntegration } from '@anticatrade/shared';
import { AppContext, appContext } from '../../../context/AppContext';

const useIntegration = (key: string | undefined, id: number | undefined) => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [metadata, setMetadata] = useState<IntegrationMetadata | null>(null);
	const [integration, setIntegration] = useState<MerchantIntegration | null>(null);

	const { api, handleError, merchant, redirect } = useContext(
		appContext as React.Context<AppContext>,
	);

	const isEdit = id != null;

	useEffect(() => {
		if (merchant == null) {
			return;
		}
		if (!merchant.features?.includes('integrations')) {
			redirect('products');
			return;
		}
		const load = async () => {
			try {
				if (isEdit) {
					const { integrations } = await api.merchantIntegrations();
					const mi = integrations.find((i) => i.id === id) ?? null;
					setIntegration(mi);
					setMetadata(mi?.metadata ?? null);
				} else {
					const { integrations } = await api.integrations();
					setMetadata(integrations.find((m) => m.key === key) ?? null);
				}
			} catch (err) {
				handleError(err as Error);
			} finally {
				setIsLoading(false);
			}
		};
		load();
	}, [merchant]);

	const save = async (settings: IntegrationSettings) => {
		if (isEdit) {
			await api.updateMerchantIntegration(id!, settings);
		} else {
			await api.addMerchantIntegration(key!, settings);
		}
	};

	return { isLoading, isEdit, metadata, integration, save };
};

export { useIntegration };
